import {
	getCCLastTransactionByCardId,
	GetCreditCardParams,
	Transaction,
} from "@/api/transactions";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { useQuery } from "@tanstack/react-query";
import { creditCardKeys } from "../credit-cards/keys";

export default function useGetCCLastTransaction(
	params: GetCreditCardParams,
	options?: QueryOptionsWithoutKeyAndFn<Transaction>,
) {
	return useQuery({
		queryFn: () => getCCLastTransactionByCardId(params),
		queryKey: creditCardKeys.getById(params.cardId),
		refetchOnWindowFocus: false,
		...options,
	});
}
